<template>
  <div v-if="isHeader">
    <span class="text-overflow text-clamp-2"
    v-tooltip="rowField.customField.label.toString().length > 24 ? rowField.customField.label : ''">{{ rowField.customField.label }}</span>
  </div>
  <div v-else-if="!isHeader"  class="is-flex is-align-items-center is-justify-content-center">
    <o-checkbox v-if="isEditable"
      v-model="cfValue"
      @update:modelValue="() => updateCfValue()"
      :disabled="!isEditable"
      class="mr-0"
    >
    </o-checkbox>
    <o-checkbox v-else
      :model-value="getVal()"
      :disabled="true"
      class="mr-0"
    >
    </o-checkbox>
  </div>
</template>

<script>

import { onBeforeMount, reactive, toRefs, inject, computed } from 'vue';
import { cloneDeep, find, isEmpty, isFunction } from 'lodash';
import { useStore } from 'vuex';

export default {
  name: 'Checkbox',
  props: {
    rowField: {
      type: Object,
      default: () => ({}),
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    isEditing: {
      type: Boolean,
    },
    emitOrderSave: {
      type: Boolean,
      default: false,
    },
    isHeader: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const shippingEvents = inject('saveShipping');
    const state = reactive({
      cfValue: false,
    });
    onBeforeMount(() => {
      if (isEmpty(props.rowData.customFields) || !find(props.rowData.customFields, { _id: props.rowField.customField._id })) {
       if(!props.rowData.customFields) {
          props.rowData.customFields = [];
        }
        props.rowData.customFields.push(cloneDeep(props.rowField.customField));
      }
      const { customField } = props.rowField;
      const itemField = find(props.rowData.customFields, { _id: customField._id });
      if (itemField && itemField.value) {
        state.cfValue = itemField.value;
      }
    });

    const updateCfValue = async () => {
      const {customField} = props.rowField;
      const itemField = find(props.rowData.customFields, {_id: customField._id})
      itemField.value = state.cfValue;
      if (props.emitOrderSave && !isEmpty(shippingEvents) && isFunction(shippingEvents.save)) {
        await shippingEvents.save(props.rowData);
      }
    };

    const isEditable = computed(() => {
      if (props.rowField.isEditable) return true;
      if (props.rowField.noEdit) return false;
      return props.isEditing;
    })

    const getVal = () => {
      const {customField} = props.rowField;
      const itemField = find(props.rowData.customFields, { _id: customField._id });
      if (itemField && itemField.value) {
        state.cfValue = itemField.value;
        return state.cfValue
      }
      state.cfValue = false
      return false;
    }

    return {
      ...toRefs(state),
      updateCfValue,
      isEditable,
      getVal
    }
  }
}

</script>